export default function sliceFilename(file) {
  file = decodeURIComponent(file);
  return (file && file.slice(file.lastIndexOf('/') + 1)) || '';
}
